module.exports = __webpack_public_path__ + "img/matana_no.071a6865.png";